import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { observer, inject } from 'mobx-react';
import styled from '@emotion/styled';
import * as DataList from 'components/DataList';
import Page from 'components/Page';
import SupplierProfile, { SupplierPageSkeleton } from 'components/Supplier/SupplierProfile';

const PageWrapGray = styled('div')`
  padding: 5px;
  background-color: #F8FAFB;
  min-height: calc(100vh - 75px);
`

// A supplier's page (/dashboard/suppliers/:id/show).
@inject('supplierStore', 'viewStore') @observer
class SuppliersShowPage extends Component {

  componentWillUnmount() {
    this.props.supplierStore.clearSelectedSupplier();
  }

  retry = () => {
    const uuid = window.location.pathname.split('/').filter(Boolean).slice(-2)[0];
    this.props.supplierStore.loadSupplier({ uuid });
  };

  updateSelectedResource = (resource) => {
    const { viewStore, supplierStore: { supplier: { object } } } = this.props;
    viewStore.supplierShowSearch.resource = resource;
    viewStore.supplierViewSearch(object.attributes.id, object.attributes.name);
  };

  // A supplier that doesn't exist (deleted, or a wrong link) gets a way back;
  // anything else (offline, server error) gets Try again.
  renderError() {
    const { supplierStore: { supplier }, viewStore } = this.props;
    const missing = supplier.errorStatus === 404 || supplier.errorStatus === 403;
    const offline = typeof navigator !== 'undefined' && navigator.onLine === false;
    const back = { label: 'Back to suppliers', icon: 'arrow-left', onClick: () => viewStore.suppliers() };
    return (
      <div className="cp-error">
        {missing ? (
          <DataList.Notice
            icon="shop"
            title="This supplier isn't here"
            message="It may have been deleted, or the link may be wrong. Find the supplier in your list instead."
            actions={[{ ...back, primary: true }]}
          />
        ) : (
          <DataList.Notice
            tone="error"
            icon={offline ? 'offline' : 'error'}
            role="alert"
            title="The supplier couldn't be loaded"
            message={offline ? "You're offline. Reconnect, then try again." : 'Something went wrong on our side. Try again in a moment.'}
            actions={[{ label: 'Try again', icon: 'refresh', onClick: this.retry, primary: true }, back]}
          />
        )}
      </div>
    );
  }

  render() {
    const { viewStore, supplierStore: { supplier: { isLoading, isError, object, errorStatus } } } = this.props;
    let content = null;
    let title;
    // Once shown, the supplier stays on screen while it reloads.
    if (object && object.id) {
      title = `${object.attributes.name} | Field Nexus`;
      content = (
        <SupplierProfile
          key={object.id}
          supplier={object}
          selectedResource={viewStore.supplierShowSearch.resource}
          onResourceChange={this.updateSelectedResource}
        />
      );
    } else if (isError && !isLoading) {
      title = `${errorStatus === 404 ? 'Supplier not found' : "Couldn't load supplier"} | Field Nexus`;
      content = this.renderError();
    } else if (isLoading) {
      title = 'Loading..';
      content = <SupplierPageSkeleton />;
    }
    return (
      <div>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <PageWrapGray>
          <Page>
            {content}
          </Page>
        </PageWrapGray>
      </div>
    );
  }
}

export default SuppliersShowPage;
